import { useState } from 'react';
import { ThemeProvider, Typography } from '@mui/material';
import '../Styles/CategoryStyles.css';
import CategoryList from '../Statefull/CategoryList/CategoryList';
import CategoryForm from '../Statefull/CategoryForm';
import EditStoreOwnerModal from '../Statefull/EditStoreOwnerModal';
import { theme } from '../../theme';

type Category = {
  id: string;
  nameEnglish: string;
  nameArabic: string;
  isActive: boolean;
  addedBy: string;
  state: boolean;
  createdUserName: string;
  categoryImage?: string;
  categoryIcon?: string;
  storeType?: 'Restaurant' | 'GroceryStore' | 'PharmacyStore';
};

const ManageCuisine = () => {
  const [modal, setModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [mode, setMode] = useState<'add' | 'edit'>('add');

  const handleEditCategory = (category: Category) => {
    setSelectedCategory(category);
    setMode('edit');
    setModal(true);
  };

  const handleAddCategory = () => {
    setSelectedCategory(null);
    setMode('add');
    setModal(true);
  };

  const handleCloseModal = () => {
    setModal(false);
    setSelectedCategory(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage Store Category
      </Typography>
      <CategoryList
        editCategory={handleEditCategory}
        setMode={setMode}
        addCategory={handleAddCategory}
      />

      <EditStoreOwnerModal
        open={modal}
        onClose={handleCloseModal}
        title={mode === 'edit' ? 'Edit Store Category' : 'Add Store Category'}
        size="md"
      >
        <CategoryForm
          mode={mode}
          onCancel={handleCloseModal}
          initialData={selectedCategory ? {
            id: selectedCategory.id,
            nameEnglish: selectedCategory.nameEnglish,
            nameArabic: selectedCategory.nameArabic,
            categoryImage: selectedCategory.categoryImage ?? '',
            categoryIcon: selectedCategory.categoryIcon ?? '',
            storeType:selectedCategory?.storeType,
          } : undefined}
        />
      </EditStoreOwnerModal>
    </ThemeProvider>
  );
};

export default ManageCuisine;
